/*!

 File: set-col-conform.js
 Author: Ember
 Version: 1.0.1
 JS Dependencies:

 CSS Dependencies:

 Description:
     Make columns the same size
*/

;(function (root, factory) {
    if ( typeof define === 'function' && define.amd ) {
        define([], function () {
			return factory(root);
		});
	} else if ( typeof exports === 'object' ) {
		module.exports = factory(root);
	} else {
		root.ColConform = factory(root);
	}
})(typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : this, function (window) {

    'use strict';

    var ColConform = (function () {

        var Constructor = function () {

    		//
    		// Variables
    		//

    		var publicAPIs = {};

            var settings = {};

            var gridArray = [];

            var resizeTimer;


    		//
    		// Methods
    		//

    		/**
    		 * A private method
    		 */
            var setGrid = function () {
                // Create an array of objects based on the rows

                var topPosition = 0;
                var currentRowStart = 0;
                var currentRow = 0;

                var elItems = document.querySelectorAll(settings.el);

                forEachNode(elItems, function (i, el) {
                    topPosition = el.offsetTop;
                    
                    // don't want to fire setheights() on the first block
                    if (i==0){
                        currentRowStart = topPosition;
                        gridArray.push([]);
                    }

                    if (currentRowStart != topPosition) {
                        //
                        // we just came to a new row.
                        currentRow ++;
                        gridArray.push([]);

                        // Reset top height to account for resized blocks in prev row
                        topPosition = el.offsetTop;
                        currentRowStart = topPosition;
                    }

                    //add element to array
                    gridArray[currentRow].push(el);

                });

                setHeights();

            }

            var setHeights = function() {
                var tallestHeight = 0;

                for(var i=0; i<=settings.innerItems.length-1; i++){

                    // each DOM element in array
                    for(var j=0; j<=gridArray.length-1; j++){
                    // each row
                        for(var k=0; k<=gridArray[j].length-1; k++){
                        // each item in row
                            // work out what the tallest height(s) are
                            if(k==0){
                                // Get height of element inside box
                                var elInner = gridArray[j][k].querySelector(settings.innerItems[i]);
                                if(elInner){
                                    tallestHeight = elInner.offsetHeight;
                                }
                                //
                            }else{
                                // Use height of element inside box
                                var elInner = gridArray[j][k].querySelector(settings.innerItems[i]);
                                tallestHeight = (tallestHeight < elInner.offsetHeight) ? (elInner.offsetHeight) : (tallestHeight);
                            }
                        }

                        for(var k=0; k<=gridArray[j].length-1; k++){
                            // apply tallest height to each item in row
                            
                            // Add height to element inside box
                            var elInner = gridArray[j][k].querySelector(settings.innerItems[i]);
                            elInner.style.height = tallestHeight+'px';
                            
                        }

                    }
                
                }
            }

            var clearHeights = function() {
                var elItems = document.querySelectorAll(settings.el);

                forEachNode(elItems, function (i, el) {
                    for(i=0; i<=settings.innerItems.length-1; i++){
                        var elInner = el.querySelector(settings.innerItems[i]);
                        if(elInner){
                            elInner.style.height = 'auto';
                        }
                    }

                });
            }

            var resetHeights = function () {
                // remove heights
                clearHeights();

                // reset variables
                gridArray.length = 0;

                // start again
                setGrid();

            }

    		var setColConform = function () {

                window.addEventListener('resize', function(e) {

                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout(function() {
                        resetHeights();       
                    }, 250);
                  
                });

                setGrid();

            };


    		/**
            * Public methods
            */
    		publicAPIs.init = function (options) {

                // Verifying and validating the input object
                if (!options) {
                    options = {};
                }

                // Validating the options
                settings.el = options.el || null;
                if(settings.el){

                    settings.innerItems = options.innerItems || null;

                    setColConform(settings.el);

                }else{
                    console.log('set-col-conform.js is missing a dom element');
                }

                // Returning the current object for chaining functions
                return this;

    		};


    		//
    		// Return the Public APIs
    		//

    		return publicAPIs;

    	};

        //
    	// Return the Constructor
    	//

    	return Constructor;


    })();

    // Returning the CardStack function to be assigned to the window object/module
    return ColConform;

});